import { FormDataConsumer, required } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import {
  AutocompleteInput,
  BooleanInput,
  AutocompleteMultiselectInput,
} from 'shared/react-admin/Inputs';
import { ReferenceArrayInput, ReferenceInput } from 'shared/react-admin/ReferenceInputs';

import { BoxStyled } from './ProviderAccountsForm.styled';
import { ProviderAccountsProviderInput } from './ProviderAccountsProviderInput';
import { ProviderAccountsWorkTeamInput } from './ProviderAccountsWorkTeamInput';

export const ProviderAccountsForm = () => {
  const { setValue } = useFormContext();

  return (
    <FormDataConsumer>
      {({ formData }) => (
        <BoxStyled>
          <BooleanInput
            label="Партнерский"
            name="partner"
            size="small"
            source="partner"
            sx={{ marginBottom: '16px', gridColumn: ' 1 / span 2' }}
            variant="outlined"
          />
          <ReferenceInput
            filter={{ archive: false }}
            perPage={200}
            reference="companies"
            source="company"
          >
            <AutocompleteInput
              filterToQuery={(searchText: string) => ({ name: searchText })}
              fullWidth
              label="Компания"
              onChange={() => {
                setValue('merchants', []);
                setValue('provider', null);
              }}
              optionText="name"
              validate={required()}
              variant="outlined"
            />
          </ReferenceInput>
          <ProviderAccountsProviderInput
            company={formData.company}
            merchants={formData.merchants}
            provider={formData.provider}
          />
          <ReferenceArrayInput
            filter={
              formData.company
                ? { companies: [formData.company], archive: false }
                : { exists: { companies: false }, archive: false }
            }
            reference="merchants"
            source="merchants"
          >
            <AutocompleteMultiselectInput
              clearOnBlur={false}
              filterToQuery={(searchText: string) => ({ name: searchText })}
              fullWidth
              label="Мерчанты"
              name="merchants"
              onChange={() => {
                setValue('provider', null);
              }}
              optionText="name"
              validate={required()}
            />
          </ReferenceArrayInput>
          <ProviderAccountsWorkTeamInput />
        </BoxStyled>
      )}
    </FormDataConsumer>
  );
};
